export default [
    {
        path: '/website-blog/topic',
        props: true,
        component: () => import('@/views/WebsiteBlog/Topic'),
    },
];